import React from "react";
import { track } from "../../../../../analytics";
import "./RouterCard.scss";

/*
  Одна карточка на два места: /router (variant full) и главная (compact).
  Отличаются объёмом характеристик, обрезкой заголовка и ссылкой на PDF;
  всё остальное общее. Поля данных не обязательны — у приставок и камер
  набор меньше, чем у роутеров, отсутствующие строки просто не рисуются.
*/

// «Частота 2,4 ГГц» + «до 574 Мбит/с» → одна строка. Вторая половина
// пары есть не везде (у приставки только названия), тогда берём первую.
const pair = (left, right) =>
  left && right ? left + ": " + right : left || right || null;

const specsOf = (data, compact) => {
  // В данных speed — это голый ярлык «Скорость передачи данных:», само
  // значение лежит в паре purity/puritySpeed. В короткой версии на ярлык
  // строки тратить нечего, показываем значение.
  const speedLine = /:\s*$/.test(data?.speed || "")
    ? pair(data?.purity, data?.puritySpeed)
    : data?.speed;

  const list = compact
    ? [data?.wifi, data?.lan, speedLine]
    : [
        data?.lan,
        data?.wifi,
        data?.speed,
        pair(data?.purity, data?.puritySpeed),
        pair(data?.purityBottom, data?.puritySpeedBottom),
        data?.ponInterface,
        data?.wifiSpeed,
        data?.standards,
        data?.vlanSupport,
        data?.multicast,
        data?.led,
      ];
  return list.filter(Boolean).slice(0, compact ? 3 : undefined);
};

const RouterCard = ({ data, setActive, iptv, variant = "full" }) => {
  const compact = variant === "compact";
  const outOfStock = data?.in_stock === false;
  const specs = specsOf(data, compact);

  return (
    <div
      className={
        "routerCard_block routerCard_block--" + variant +
        (iptv ? " routerCard_block--iptv" : "")
      }
    >
      <div className="routerCard_art">
        {data?.isNew && (
          <div className="routerCard_badges">
            <span className="routerCard_badge">Новинка</span>
          </div>
        )}
        <img src={data?.img} alt="" />
      </div>

      {data?.subTitle && <p className="routerCard_eyebrow">{data.subTitle}</p>}
      <h2>{data?.title}</h2>

      {specs.length > 0 && (
        <ul className="routerCard_specs">
          {specs.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      )}

      <div className="routerCard_price">
        <div className="routerCard_priceRow">
          <h3>{data?.price}</h3>
          {data?.oldPrice && <s className="routerCard_oldPrice">{data.oldPrice}</s>}
        </div>
        {data?.installment && <p>{data.installment}</p>}
      </div>

      <div className="routerCard_btn">
        {outOfStock ? (
          <div className="routerCard_outOfStock">
            <span className="routerCard_outOfStock__dot" />
            Нет в наличии
          </div>
        ) : (
          <button
            type="button"
            className="routerCard_buy"
            onClick={() => {
              track("cta_click", {
                place: iptv ? "iptv_device" : "router",
                label: "Купить",
                product: data?.name || data?.title || "",
              });
              setActive && setActive(true);
            }}
          >
            Купить
          </button>
        )}
      </div>

      {/* Ссылки на сам файл в данных нет — пока это подпись с иконкой.
          Появится downloadLink — строка станет настоящей ссылкой. */}
      {!compact && data?.download && (
        data?.downloadLink ? (
          <a className="routerCard_download" href={data.downloadLink} download>
            {data.downloadIcon}
            {data.download}
          </a>
        ) : (
          <p className="routerCard_download">
            {data.downloadIcon}
            {data.download}
          </p>
        )
      )}
    </div>
  );
};

export default RouterCard;
